import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const NewsList = Loadable(lazy(() => import("features/news/components/List")));
const NewsPage = Loadable(lazy(() => import("features/news/components/Page")));
const NewsUpload = Loadable(lazy(() => import("features/news/components/UploadPage")));


const routes = {
  path: "news",
  children: [
    { path: "", element: <NewsList /> },
    { path: "add", element: <NewsPage /> },
    { path: "edit/:newsID?", element: <NewsPage /> },
    { path: "upload", element: <NewsUpload /> },
  ],
};

export default routes;
